module.exports = __webpack_public_path__ + "assets/be4961986a3575843f46c2f80117ffd0.svg";